import { BrowserRouter, Routes, Route,useNavigate } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import axios from 'axios';
import baseUrl from './components/baseUrl';
import LogIn from "./pages/LogIn/LogIn";
import Signup from "./pages/SignUp/Signup";
import Home from "./pages/Home/Home";
import Blog from "./pages/Blog/Blog";
import BlogDetail from './pages/Blog/BlogDetail';
import Dashboard from "./pages/Dashboard/Dashboard";
import { useEffect, useState } from "react";
import Rate from "./pages/Rate/Rate";
import Edit from "./pages/EditReview/Edit";
import Submit from "./pages/Submit/Submit";
import ClaimBusiness from "./pages/Claimbusiness";
import Vendor from "./pages/Vendor/Vendor";
import Profile from "./pages/Profile/Profile";
import About from "./pages/FooterPages/About";
import Contact from "./pages/FooterPages/Contact";  
import SiteGuidelines from "./pages/FooterPages/SiteGuidelines";  
import PrivacyPolicy from "./pages/FooterPages/PrivacyPolicy";
import Terms from "./pages/FooterPages/Terms";
import { AuthProvider } from './context/AuthContext';
import SocialCallback from './pages/SocialCallback';



function App() {
  const [reviewData, setReviewData] = useState([])
  const [vendorCountryData, setVendorCountryData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [eventData, setEventData] = useState([])
  const [vendorData, setVendorData] = useState([])
  const [savedVendorData, setSavedVendorData] = useState([]);

 

  const token = localStorage.getItem('raw_auth_token'); // raw JWT

  
  



  const fetchFeedbackData = async () => {
    try {
      await axios.get(`${baseUrl}/feedbacks`).then(response => {
        setReviewData(response?.data?.data)
      })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // Fetch vendor Countries
  const fetchVendorCountryData = async () => {
    try {
      await axios.get(`${baseUrl}/vendor-countries`).then(response => {
        setVendorCountryData(response?.data?.data)
      })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // Fetch Categories
  const fetchCategoryData = async () => {
    try {
      await axios.get(`${baseUrl}/categories`).then(response => {
        setCategoryData(response?.data?.data)
      })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }


    // Fetch Events
    const fetchEventData = async () => {
      try {
        await axios.get(`${baseUrl}/events`).then(response => {
          setEventData(response?.data?.data)
        })
          .catch((error) => {
            console.log(error)
          })
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  // Fetch Vendors
  const fetchVendorData = async () => {
    try {
      await axios.get(`${baseUrl}/vendors`).then(response => {
        setVendorData(response?.data?.data)
      })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const fetchSavedVendorsData = async () => {
    const encoded = localStorage.getItem(
      "jdgbgiusudgfdyudbudvfudhfgbiyfudvifiudubuydfbduvuydfvuy"
    );
  
    if (!encoded) return;
  
    const token = JSON.parse(atob(encoded)); // decode right here
  
    try {
      const res = await axios.get(`${baseUrl}/saved-vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      setSavedVendorData(res.data);
    } catch (err) {
      console.error("Fetch saved vendors failed:", err);
    }
  };
  
  

  

  useEffect(() => {
    Aos.init();

    fetchFeedbackData()
    fetchVendorCountryData()
    fetchCategoryData()
    fetchEventData()
    fetchVendorData()
  }, []);

  useEffect(() => {
    fetchSavedVendorsData();
  }, []);
  

  const toggleSaveVendor = async (vendor) => {
    const isSaved = savedVendorData.some(v => v.vendor_id === vendor.vendor_id);
  
    try {
      if (isSaved) {
        await axios.delete(`${baseUrl}/saved-vendors/${vendor.vendor_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSavedVendorData(prev => prev.filter(v => v.vendor_id !== vendor.vendor_id));
      } else {
        await axios.post(`${baseUrl}/saved-vendors`, { vendor_id: vendor.vendor_id }, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSavedVendorData(prev => [...prev, vendor]);
      }
    } catch (err) {
      console.error("Failed to toggle save vendor:", err.response?.data || err.message);
    }
  };
  
  
  

  
  return (
    <div>
        <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LogIn  fetchSavedVendorsData={fetchSavedVendorsData} />} />
          <Route path="/signup" element={<Signup />} />
          {/* Backend should redirect to this path with ?token=... */}
          <Route path="/auth/social-callback" element={<SocialCallback />} />

          <Route index element={<Home reviewData={reviewData} vendorCountryData={vendorCountryData} categoryData={categoryData}  vendorData={vendorData} />} />
          <Route path="/dashboard" element={<Dashboard reviewData={reviewData} vendorCountryData={vendorCountryData} categoryData={categoryData} vendorData={vendorData} savedVendorData={savedVendorData} setSavedVendorData={setSavedVendorData} toggleSaveVendor={toggleSaveVendor} /> } />
          <Route path="/rate" element={<Rate reviewData={reviewData} vendorCountryData={vendorCountryData} categoryData={categoryData} eventData={eventData} vendorData={vendorData} />} />
          <Route path="/submit" element={<Submit reviewData={reviewData} vendorCountryData={vendorCountryData} categoryData={categoryData} eventData={eventData} />} />
          <Route path="/claimbusiness" element={<ClaimBusiness vendorData={vendorData} />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/vendor" element={<Vendor savedVendorData={savedVendorData} toggleSaveVendor={toggleSaveVendor}/>} />
          <Route path="/profile" element={<Profile reviewData={reviewData}/>} />
          <Route path="/edit" element={<Edit reviewData={reviewData} vendorCountryData={vendorCountryData} categoryData={categoryData} eventData={eventData} />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/site-guidelines" element={<SiteGuidelines />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          {/* <Route path="/about" element={<About/>}/>
              <Route path="/contact" element={<Contact/>} />
              <Route path="/list" element={<ListProperty/>}/>
              <Route path="/facility_type/:data" element={<Search/>} />
              <Route path="/moredetails" element={<MoreDetails/>} />
              <Route path="/*" element={<ErrorPage/>} /> */}
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
